import React from "react";
import {
  Card,
  Row,
  Col,
  Input,
  Button,
  Typography,
} from "antd";

const { Text } = Typography;

const RecPrePayment = ({
  paymentDetails,
  loading,
  onBack,
  onPay,
}) => {
  const formattedAmount = Number(
    paymentDetails?.amount || 0
  ).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div className="rec-payment-wrapper">
      <Card className="rec-payment-card">
        <div className="rec-payment-header">
          Payment
        </div>

        <div className="rec-payment-note">
          <Text strong>Note:</Text>
          {" "}
          Please save your Application ID for future reference.
        </div>

        <Row gutter={16}>
          <Col xs={24} md={8}>
            <div className="rec-field-label">
              Application ID
            </div>

            <Input
              value={paymentDetails?.application_id}
              disabled
            />
          </Col>

          <Col xs={24} md={8}>
            <div className="rec-field-label">
              Payment Amount
            </div>

            <Input
              value={`₹ ${formattedAmount}`}
              disabled
            />
          </Col>

          <Col xs={24} md={8}>
            <div className="rec-field-label">
              Payment Currency
            </div>

            <Input
              value="INR"
              disabled
            />
          </Col>
        </Row>

        <div className="rec-payment-actions">
          <Button
            size="large"
            onClick={onBack}
          >
            Back
          </Button>

          <Button
            type="primary"
            size="large"
            loading={loading}
            onClick={onPay}
            className="rec-primary-btn"
          >
            Make Payment
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default RecPrePayment;